// extracted by mini-css-extract-plugin
export default {"small":"IconInfo_small__HwRKV"};